export default __webpack_public_path__ + "static/img/share.f518493.jpeg";